import styled, { keyframes } from "styled-components"
import Box from "~/components/UI/Box"
import getcdn from "~/modules/get_cdn_link"
import Image from "~/components/UI/Image"
import breakpoints from "~/components/UI/breakpoints"
import Link from "next/link"
import { ROUTES } from "~/constant"

const MyContainer = styled(Box)`
  max-width: 864px;
  height: 100px;
  margin: 30px auto 60px 0;
  padding: 0 20px;
  ${breakpoints.md} {
    margin: 60px auto;
  }
`
const loop = keyframes`
  0 {
    transform: translateX(-10%)
  }

  100% {
    transform: translateX(-100%)
  }
`

const Img = styled(Image)`
  padding-right: 16px;
  height: 100px;
  animation: ${loop} infinite 10s linear;
  /* ${breakpoints.md} {
    animation: none;
  } */
`

// const Linear = styled.div`
//   background-image: linear-gradient( to left, #fff, rgba(255,0,0,0), #fff);
//   height: 100%;
//   position: absolute;
//   width: 100vw;
//   left: 50%;
//   transform: translateX(-50%);
// `

const Press = () => {
  return (

    <Link href={ROUTES.PRESS}>
      <a>
        <MyContainer flex style={{ overflow: 'hidden' }}>
          <Img
            xsStyle={{ height: '100%' }}
            mdStyle={{ width: '100%', }}
            src={getcdn('/images/home/press2.png')} alt='home_press'
            height={100}
            width={838}
          />
          <Img
            xsStyle={{ height: '100%', display: 'block' }}
            // mdStyle={{ display: 'none' }}
            mdStyle={{ width: '100%', }}
            height={100}
            width={838}
            src={getcdn('/images/home/press2.png')} alt='home_press' />
          {/* <Linear /> */}
        </MyContainer>
      </a>
    </Link>
  )
}

export default Press